import { render } from "./DataPrivacy.vue?vue&type=template&id=3366b292&scoped=true"
import script from "./DataPrivacy.vue?vue&type=script&lang=js"
export * from "./DataPrivacy.vue?vue&type=script&lang=js"

import "./DataPrivacy.vue?vue&type=style&index=0&id=3366b292&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe/Safe_Sites_Modifs/SAFE_MED/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3366b292"]])

export default __exports__